$('.image-banner__btn').each(function(i, elem) {
	const btn = $(elem);
	const imageBanner = btn.parents('.image-banner');

	if (!imageBanner.find('.overlay-link').length) {
		imageBanner.append('<a href="' + btn.attr('href') + '" class="overlay-link"></a>');
	}
});

initSwipers();

$(window).on('resize', function() {
	initSwipers();
});

function initSwipers() {
	$('.swiper-container').each(function () {
		let container = $(this);
		let swiperInstance;

		if (container[0].swiper) {
			container[0].swiper.destroy();
		}

		if (container.hasClass('product-gallery')) {
			swiperInstance = new Swiper(container[0], {
				speed: 500,
				slidesPerView: 'auto',
				autoHeight: true,
				direction: 'vertical',
				mousewheel: {
					forceToAxis: true
				},
				loop: true,
				// spaceBetween: 20,
			});
		}

		if (container.hasClass('product-gallery-thumbs')) {
			swiperInstance = new Swiper(container[0], {
				speed: 500,
				slidesPerView: 'auto',
				autoHeight: true,
				direction: 'vertical',
				mousewheel: {
					forceToAxis: true
				},
				freeMode: true,
				slideToClickedSlide: true,
				// spaceBetween: 20,
			});
		}
	})

	$('.swiper-container').each(function () {
		let container = $(this);
		let swiperInstance = container[0].swiper;

		if (container.hasClass('product-gallery')) {
			swiperInstance.on('slideChange', function () {
				container.parents('.product-gallery-wrapper').find('.product-gallery-thumbs')[0].swiper.slideTo(swiperInstance.realIndex, 500);
			});
		}

		if (container.hasClass('product-gallery-thumbs')) {
			container.find('.swiper-slide').on('click', function () {
				const slide = $(this);
				container.parents('.product-gallery-wrapper').find('.product-gallery')[0].swiper.slideTo(slide.index(), 500);
			});
		}
	})
}
